export const toIsoDate = (dateStr) => {
  if (!dateStr) return '';
  const [month, day, year] = dateStr.split('/');
  if (!year || !month || !day) return dateStr;
  return `${year.padStart(4, '0')}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export const parseCsvRows = (rows, yesNoToBool) =>
  rows.map((row) => ({
    patient_id: parseInt(Object.entries(row).find(([key]) => key.toLowerCase() === 'mrn')?.[1], 10),
    start_date: toIsoDate(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'date start')?.[1],
    ),
    end_date: toIsoDate(Object.entries(row).find(([key]) => key.toLowerCase() === 'date end')?.[1]),
    chart_notes: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'chart notes')?.[1],
    ),
    bgm_reading_logs: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'reading logs bgm')?.[1],
    ),
    cgm_reading_logs: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'reading logs cgm')?.[1],
    ),
    orders_and_consent: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'orders and informed consent')?.[1],
    ),
    rpm_claim_documentation: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'rpm claim documentation')?.[1],
    ),
    em_claim_documentation: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'em claim documentation')?.[1],
    ),
    hawb_claim_documentation: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'hawb claim documentation')?.[1],
    ),
    ccm_claim_documentation: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'ccm claim documentation')?.[1],
    ),
    blood_pressure: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'blood pressure')?.[1],
    ),
    med_pickup_date: yesNoToBool(
      Object.entries(row).find(([key]) => key.toLowerCase() === 'med pickup date')?.[1],
    ),
    hba1c: yesNoToBool(Object.entries(row).find(([key]) => key.toLowerCase() === 'hba1c')?.[1]),
  }));
